import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";

import App from "./App";
import store from "./Redux/store";
import Loader from "./layouts/loader/Loader";
import "./assets/scss/style.scss";

import "./index.css";

ReactDOM.render(
  <HashRouter>
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </HashRouter>,

  document.getElementById("root")
);
